import { resolveText } from '../../i18n/resolveText';
export function renderAboutSlideshow(block) {
    const section = document.createElement('section');
    section.className = 'about';
    const slidesHtml = block.slides
        .map((src, index) => `<img class="about__slide" src="${src}" alt="Lady Space" style="animation-delay:${-4 * index}s;">`)
        .join('');
    section.innerHTML = `
    <div class="about__frame">
      ${slidesHtml}
      <div class="about__gradient" aria-hidden="true"></div>
      <div class="about__content">
        <div class="about__title">${resolveText(block.title)}</div>
        <p class="about__text">${resolveText(block.text)}</p>
        <div class="about__signature">${resolveText(block.signature)}</div>
      </div>
    </div>
  `;
    return section;
}
